<template>
  <div class="box-2">
    <ul class="cat-tinh" :style="{'height': customHeight}">
      <li v-for="(item, k) in cattinh" :key="k">
        <a style="cursor: pointer" @click="showModal(item.name)">{{ item.name }}</a>
      </li>
    </ul>
    <ul class="hung-tinh" :style="{'height': customHeight}">
      <li v-for="(item, k) in hungtinh" :key="k">
        <a style="cursor: pointer" @click="showModal(item.name)">{{ item.name }}</a>
      </li>
    </ul>
    <a-modal v-model="visible" :title="data.title" @ok="handleOk">
      <p>{{ data.title }}</p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'ItemThanSat',
  props: {
    cattinh: {
      type: Array,
      default: null
    },
    hungtinh: {
      type: Array,
      default: null
    },
    customHeight: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      visible: false,
      data: {}
    }
  },
  methods: {
    showModal (title) {
      this.visible = true
      this.data = {
        title
      }
    },
    handleOk () {
      this.visible = false
    }
  }
}
</script>

<style scoped>
  section .box-2 {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -moz-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
  }
  section .box-2 ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    min-height: 120px;
    overflow-y: scroll;
    -moz-flex-basis: 50%;
    -ms-flex-basis: 50%;
    -webkit-flex-basis: 50%;
    flex-basis: 50%;
    -webkit-transition: all .5s;
  }
  section .box-2 ul:hover::-webkit-scrollbar-thumb {
    background: rgba(51, 51, 51, 0.67);
  }
  section .box-2 ul::-webkit-scrollbar {
    width: 3px;
  }
  section .box-2 ul::-webkit-scrollbar-track {
    background: transparent;
  }
  section .box-2 ul::-webkit-scrollbar-thumb {
    background: transparent;
  }
  section .box-2 ul::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  section .box-2 ul li a {
    font-size: 14px;
  }
  section .box-2 ul li a:hover {
    font-weight: bold;
  }
  section .box-2 ul.cat-tinh li a {
    color: #0002ff;
  }
  section .box-2 ul.hung-tinh li a {
    color: red;
  }
  section #yNghiaThanSat {
    max-height: 400px;
    overflow-y: scroll;
    /* width */
    /* Track */
    /* Handle */
    /* Handle on hover */
  }
  section #yNghiaThanSat:hover::-webkit-scrollbar-thumb {
    background: rgba(51, 51, 51, 0.67);
  }
  section #yNghiaThanSat::-webkit-scrollbar {
    width: 5px;
  }
  section #yNghiaThanSat::-webkit-scrollbar-track {
    background: transparent;
  }
  section #yNghiaThanSat::-webkit-scrollbar-thumb {
    background: transparent;
  }
  section #yNghiaThanSat::-webkit-scrollbar-thumb:hover {
    background: #333;
  }

  section li {
    font-weight: normal !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
    font-size: 1rem !important;
    border-bottom: none !important;
  }
</style>
